module.exports = __webpack_public_path__ + "static/img/product-banner-title.a2c366a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-banner-title.png
// module id = Z0/C
// module chunks = 0